import React from 'react'
import TopSec from '../../Component/About/Topsec'
import Who from '../../Component/About/Who'
import Core from '../../Component/About/Core'
import Meet from '../../Component/About/Meet'
import Seo from '../../Component/Seo'

function Aboutus() {
  return (
    <div>
      <Seo
        title='About Halal Wealth | Ethical Islamic Finance Platform'
        description='Learn about Halal Wealth, our mission, and how we help people save and invest through transparent, Shariah-compliant financial products.'
        pathname='/aboutus'
      />
      <TopSec/>
      <Who/>
      <Core/>
      {/* <Meet/> */}
    </div>
  )
}

export default Aboutus
